import React, { useRef } from 'react';

import ModalVideo from '../ModalVideo';
import { TextVideo3_Nuno } from '../../../../../utils/ES/Modals/directors';

const ModalVideoNuno3 = () => {
  return (
    <>
      <ModalVideo
        id="nuno-video-3"
        dataText={TextVideo3_Nuno}
        videoSrc="https://player.vimeo.com/video/1095762363?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
        videoTitle="KUTER_STUDIO_DIRECTORS_NUNO_3"
      />
    </>
  );
};

export default ModalVideoNuno3;
